// import React from 'react';
//import Dashboard from "views/Front/Dashboard";
import MemberLogin from "views/Auth/Member/Login";
const FrontRoutes = [
  //{ path: "/", exact: true, name: "Dashboard", component: Dashboard }
  { path: "/", exact: true, name: "MemberLogin", component: MemberLogin },
];

export default FrontRoutes;
